// @flow

import { singular as singularizer } from 'pluralize';

const singular = (value: string) => singularizer(value);

export default singular;
